module.exports = __webpack_public_path__ + "static/quiz4_question5-367e00d7423dfaca98d024719b25af37.jpg";